export default "__VITE_ASSET__6MHvPS0T__"